import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M640-180v-236.15h140V-180zm-230 0v-600h140v600zm-230 0v-403.84h140V-180z"></path>
  </svg>
);

export default React.memo(SvgIcon);
